const riot = require('riot');

riot.tag2('page-loan', '<div class="sticky t0 z100" data-is="module-header" title="{t(&quot;loan.title&quot;)}" close="{true}"></div> <div class="bg-cream s-full py24"> <div class="container px20"> <div class="fw6 fs16 lh10 mb16">{t(⁗loan.amount⁗)}</div> <div class="fw6 fs24 lh10 mb28">{loan.amount}{app.utils.getCurrencyText(currency, (loan.amount !== 1))}</div> <div class="fw6 fs16 lh10 mb16">{t(⁗loan.purpose⁗)}</div> <div class="fw6 fs24 lh10 mb28">{loan.message}</div> <div class="mb38"> <div class="lh15 fw4 fs15 mb16 mb0-last" each="{description in getDescriptions()}">{description}</div> </div> </div> <div class="container px16"> <div class="mb20" data-is="atom-action-button" text="{t(&quot;loan.approve&quot;)}" onclick="{approveLoan}"></div> <div class="mb20" data-is="atom-action-button" negative="{true}" text="{t(&quot;loan.deny&quot;)}" onclick="{denyLoan}"></div> </div> </div>', '', '', function(opts) {
    this.preload = async({req, res}) => {

      var me_res = app.api.request({
        method: 'get',
        url: '/web/me',
      });

      var child_res = app.api.request({
        method: 'get',
        url: `/web/children/${req.params.id}`,
      });

      var loan_res = app.api.request({
        method: 'get',
        url: `/web/children/${req.params.id}/bank/loan/requests/review`,
      });

      var promises = [
        me_res,
        child_res,
        loan_res,
      ];

      var items = await Promise.all(promises);

      return {
        currency: items[0].data.family.currency,
        child: items[1].data.child,
        loan: items[2].data.loan_request,
      }
    };

    this.getDescriptions = () => {
      return [
        t("loan.for_guardians_description_1"),
        t("loan.for_guardians_description_2"),
      ];
    };

    this.approveLoan = async () => {
      await app.api.request({
        method: 'put',
        url: `/web/children/${this.child.id}/bank/loan/requests/${this.loan.id}/apply`,
        data: {},
      });

      spat.router.push('/');

      spat.modal.alert(t("loan.approve_message"));
    };

    this.denyLoan = async () => {
      await app.api.request({
        method: 'put',
        url: `/web/children/${this.child.id}/bank/loan/requests/${this.loan.id}/reject`,
        data: {},
      });

      spat.router.push('/');

      spat.modal.alert(t("loan.deny_message"));
    };
});